import React from "react";
import { Sigin, SignUp } from "../auth";
import ForgotPassword from "../components/ForgotPassword";
import VerifyEmail from "../components/VerifyEmail";


const publicRoutes = [
  { path: "/", element: <Sigin /> },
  { path: "/signUp", element: <SignUp /> },
  { path: "/verify-email", element: <VerifyEmail /> },
  { path: "/forgot", element: <ForgotPassword /> },
];

export default publicRoutes;